import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { createRoot, Root } from 'react-dom/client';
import { ViewCareCompanion } from '../../../patient/src/features/care_companion';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactCareCompanionComponent';

@Component({
	standalone: false,
	selector: 'care-companion-component',
	template: `
		<semantic-view>
			<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
			<footer-component footer></footer-component>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class CareCompanionWrapper implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(
		private readonly activatedRoute: ActivatedRoute,
		private readonly ngZone: NgZone,
	) {}

	ngAfterViewInit(): void {
		this.root = createRoot(this.containerRef.nativeElement);
		const sessionId = this.activatedRoute.snapshot.paramMap.get('sessionId') ?? undefined;

		this.ngZone.runOutsideAngular(() => {
			this.root.render(
				<CellulaProviderWrapper useGlobals>
					<ViewCareCompanion sessionId={sessionId} />
				</CellulaProviderWrapper>,
			);
		});
	}

	ngOnDestroy(): void {
		this.root?.unmount();
	}
}
